*,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  user-select: none;
  display: inline-block;
}
